<template>
  <v-text-field v-model="value" @input="sync" :label="label" :readonly="readonly" :placeholder="label" :rules="rules" />
</template>

<script>
import DefaultField from './default'

export default {
  mixins: [DefaultField],
  data: () => ({
    value: 'integer field'
  }),
  methods: {
    normalize () {
      let value = '' + this.value
      let norm = parseInt(this.value)
      if (isNaN(norm)) {
        norm = ''
      }
      this.value = norm
    }
  }
}
</script>
